import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import { hasPermission } from "../../utils/permissionUtils";
import { Sliders, Users } from "react-feather";

const useEventItems = () => {
  const { isAuthenticated, isInitialized, user } = useAuth();
  const [navItems, setNavItems] = useState([]);

  useEffect(() => {
    if (!isInitialized) return;

    if (!isAuthenticated) {
      setNavItems([]);
      return;
    }

    // Always show events-specific navigation regardless of user type
    const eventsNavItems = [
      {
        title: "Events",
        pages: [
          hasPermission("VIEW_EVENTS") && {
            href: "dashboard",
            icon: Sliders,
            title: "Dashboard",
          },
          hasPermission("VIEW_EVENTS") && {
            href: "/events/events",
            icon: Users,
            title: "Events",
          },
        ].filter(Boolean),
      },
    ];

    setNavItems(eventsNavItems);
  }, [isInitialized, isAuthenticated, user]); // Dependencies are now stable

  return navItems;
};

export default useEventItems;
